import { css } from '@emotion/react'
import { graphql } from 'gatsby'
import { ComponentPropsWithoutRef, useState } from 'react'

import { Accordion } from '@/features/common/'
import { BodyTextBlock } from '@/features/common/'
import { colors } from '@/theme/variables'

import {
  DivisionFilter,
  DivisionFilterData,
} from '../DivisionFilter/DivisionFilter'

interface Props extends ComponentPropsWithoutRef<'section'> {
  data?: readonly (Queries.AdmissionsFaqItemFragment | null)[] | null
}

export const AdmissionsFAQ = ({
  data,
  ...props
}: Props): JSX.Element => {
  const [activeFilter, setActiveFilter] = useState<DivisionFilterData>()
  const faqs = data?.filter(faqItem => {
    if (activeFilter) {
      const divisionIds = faqItem?.division?.map(
        division => division?.id
      )
      return divisionIds?.includes(activeFilter.id)
    } else if (!faqItem?.division?.[0]) {
      return true
    }
  })
  const styles = {
    section: css`
      padding: var(--row-72) var(--margin);
      background: #fff;
      border-top: 1rem solid ${colors.gray95};
    `,
    accordion: css`
      --border-color: #00000033;
    `,
    faqItemHeading: css`
      && {
        margin: 0.5em 0;
      }
    `,
    faqItemBody: css`
      padding: 0 0 2em;
      > p:first-of-type {
        margin-top: 0;
      }
    `,
  }
  return (
    <section
      css={styles.section}
      {...props}
    >
      <DivisionFilter
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        allLabel="General Questions"
      />
      <Accordion
        css={styles.accordion}
        data={{
          items: faqs?.map(faqItem => ({
            heading: (
              <h3 css={styles.faqItemHeading}>{faqItem?.question}</h3>
            ),
            content: (
              <BodyTextBlock
                css={styles.faqItemBody}
                data={faqItem?.answer}
              />
            ),
          })),
        }}
      />
    </section>
  )
}

export const AdmissionsFaqItemFragment = graphql`
  fragment AdmissionsFaqItem on DatoCmsAdmissionsFaqItem {
    id: originalId
    __typename
    question
    answer {
      ...BodyTextBlock
    }
    division {
      id: originalId
      divisionName
    }
  }
`
